import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4814c30&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../style/index.scss?vue&type=style&index=0&id=a4814c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4814c30",
  null
  
)

export default component.exports